import React, { useState } from "react"
import { parsePhoneNumberFromString } from "libphonenumber-js"

const numberAsE164 = (phoneNumber) => {
  const parsed = parsePhoneNumberFromString(phoneNumber || "", "US")
  return parsed ? parsed.number : phoneNumber
}

const formatted = (phoneNumber) => {
  const parsed = parsePhoneNumberFromString(phoneNumber || "", "US")

  if (parsed && parsed.countryCallingCode === "1") {
    return parsed.formatNational()
  } else if (parsed) {
    return parsed.formatInternational()
  } else {
    return phoneNumber
  }
}

const FormPhoneInput = (props) => {
  const [value, setValue] = useState(formatted(props.value))
  return (
    <div>
      <input type="hidden" name={props.name} value={numberAsE164(value)} />
      <input
        type="tel"
        placeholder="555-555-5555"
        value={value}
        onChange={(e) => {
          setValue(e.target.value)
        }}
        className="form-control"
        data-role={props.data_role}
      />
    </div>
  )
}

export default FormPhoneInput
